"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMuiList = void 0;
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
exports.StyledMuiList = (0, styles_1.styled)(material_1.List, { shouldForwardProp: prop => prop !== "withScroll" })(({ theme, withScroll }) => ({
    overflowX: withScroll ? "scroll" : "inherit",
    [theme.breakpoints.down("xs")]: {},
}));
//# sourceMappingURL=styled.js.map